import { graphql } from '@graphql/gql';

export const SEARCH_SESSIONS = graphql(`
  query SEARCH_SESSIONS($criteria: SearchSessionCriteria, $virtualAttendee: Boolean, $enableSessionCapacity: Boolean!) {
    searchSessions(criteria: $criteria) {
      pagination {
        currentToken
        nextToken
        previousToken
        limit
        totalCount
      }
      data {
        id
        name
        code
        start
        end
        description
        enrolled
        included
        featured
        virtual
        openForRegistration
        capacity(virtualAttendee: $virtualAttendee) @include(if: $enableSessionCapacity) {
          active
          availableCapacity
          totalCapacityAvailable
        }
        category {
          id
          name
          code
        }
        location {
          id
          name
          code
        }
        admissionItems @appFeature(feature: "upgradeAdmissionItem")
        upgrade @appFeature(feature: "upgradeAdmissionItem")
        openForAttendeeHub
        recommended
        sessionSpeakers {
          id
          firstName
          lastName
          company
          title
          profileImageUri
          designation
          prefix
        }
        sessionTags
        customFields {
          name
          plannerSelected
          value
        }
        exhibitors {
          id
          name
          description
          profileLogoId
          profileLogoUrl
          hidden
          featured
          eventSponsor
          sponsorshipLevelId
        }
        fee @appFeature(feature: "sessionFee") {
          amount
        }
        webcast {
          id
          sessionId
          eventId
          format
          playerType
          onDemandVideo
          isOnDemandContentPlayable
          player {
            id
            playerTypeProvider
            stream {
              id
              status
            }
            duration
            simuliveOffset
          }
        }
      }
    }
  }
`);
